import {getTranslator} from "../../../translate";
import Api from "../../../api/api";
import React, {useState} from "react";
import {LoadingScreen} from "../loadingScreen";
import {CountryIcon, GameIconTK, GameIconTL} from "../ui/tIcon";
import {FormatDateTimeShorter} from "../../../helper/dateTime";
import {URL} from "../ui/link";

export default function TravianServerList() {
    const [serverData, setServerData] = useState(null);

    if (serverData === null) {
        Api.get('travian/serverInstance/displayable').then(data => setServerData(data));
        return <LoadingScreen />;
    }

    const translator = getTranslator('page/travianServerList');
    // noinspection JSCheckFunctionSignatures,JSUnresolvedVariable
    return <>
        <div className={'updaterInfo'}>
            <span dangerouslySetInnerHTML={{__html: translator('latestDataInfo')}} />&nbsp;
            <URL href={'info'}>{translator('moreInfo')}</URL>
        </div>

        <table className={'travianServerList'} style={{width: "100%", minWidth: "1024px", maxWidth: "1440px"}}>
            <thead>
                <tr>
                    <td>{translator('region')}</td>
                    <td>{translator('serverName')}</td>
                    <td>{translator('gameVersion')}</td>
                    <td>{translator('serverSpeed')}</td>
                    <td>{translator('specialFeatures')}</td>
                    <td>{translator('serverStart')}</td>
                    <td>{translator('serverAge')}</td>
                    <td>{translator('latestUpdateDataFrom')}</td>
                    <td>{translator('serverLink')}</td>
                </tr>
            </thead>
            <tbody>
                {
                    Object.values(serverData).sort((a, b) => b.start - a.start).map(server => {
                        let serverName = server.shortname;
                        if (server.tgname !== null && server.url.match(/^ts[0-9]+\.x[0-9]+\.[a-z]+\.travian\.com$/) === null) {
                            serverName += ' (' + server.tgname + ')';
                        }
                        return <tr key={server.id}>
                            <td><CountryIcon country={server.country} /></td>
                            <td>{serverName}</td>
                            <td>{server.tmajor === 5 ? <GameIconTK /> : <GameIconTL />} {server.tmajor === 5 ? 'TK' : 'T:L'}</td>
                            <td className={'speed-' + server.speed}>{server.speed}x</td>
                            <td>N/A</td>
                            <td className={server.start * 1000 > Date.now() ? 'future-start' : ''}>{FormatDateTimeShorter(server.start)}</td>
                            <td>{Math.floor((Date.now() / 1000 - server.start) / 86400)} {translator('serverAgeUnit')}</td>
                            <td>{server.lastDataFrom === null ? '-' : FormatDateTimeShorter(server.lastDataFrom)}</td>
                            <td><a href={'https://' + server.url + '/'} target={'_blank'}>{server.url}</a></td>
                        </tr>
                    })
                }
            </tbody>
        </table>
    </>;
}
